<template>
  <div class="detailContract" v-if="canAccessMx('CNPS_SCON_INFO_BY_ID')">
    <Header
      title="Chi tiết HĐG thanh toán"
      :backUrl="
        canAccessMx('CNPS_SCON_LIST_PAYMENT')
          ? '/contract-manager?groupService=PAYMENT'
          : '/contract-manager'
      "
    />
    <div class="d-flex align-items-center">
      <ContractAction :actions="extendedContractAction" :excepts="[actCode.OTP]" class="mb-0" />
    </div>
    <!-- End Breadcrumb Area -->
    <div class="row px-20 b-t-1-869fb229 pt-15">
      <div class="col-md-6 px-1">
        <div class="form-detail mb-3" v-if="dataContract.nganluongTransferStatus">
          <div class="d-flex justify-content-between align-items-center mb-2 pb-2">
            <h1 class="pb-2">Yêu cầu chuyển đổi HĐ Ngân lượng</h1>
            <div
              v-if="dataContract?.nganluongTransferStatus === 'PENDING'"
              class="d-flex ml-2"
              style="min-width: 140px"
            >
              <span
                class="mr-2 font-weight-bold btn btn-success"
                style="cursor: pointer; font-size: 13px"
                @click="showmodalApproveTransferNL = true"
                >Duyệt</span
              >
              <span
                class="font-weight-bold btn btn-danger"
                style="cursor: pointer; font-size: 13px"
                @click="showmodalRejectTransferNL = true"
                >Từ chối</span
              >
            </div>
          </div>
          <table class="table-borderless w-100 f13">
            <tbody>
              <tr>
                <td style="width: 150px; vertical-align: top; padding-bottom: 8px; color: #666">
                  Mã HĐ ngân lượng
                </td>
                <td style="vertical-align: top; padding-bottom: 8px">
                  : {{ dataContract?.nganluongCodePending }}
                </td>
              </tr>
              <tr>
                <td style="vertical-align: top; padding-bottom: 8px; color: #666">Trạng thái</td>
                <td style="vertical-align: top; padding-bottom: 8px">
                  :
                  <span class="badge" :class="[dataContract?.nganluongTransferStatus]">
                    {{ dataContract?.nganluongTransferStatus | mapNganluongTransferStatus }}
                  </span>
                </td>
              </tr>
              <tr v-if="dataContract?.nganluongTransferStatus === 'REJECTED'">
                <td style="vertical-align: top; padding-bottom: 8px; color: #666">Lý do</td>
                <td style="vertical-align: top; padding-bottom: 8px">
                  :
                  {{ dataContract?.nganluongTransferRejectReason }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <McInfo
          :contract="dataContract"
          :item="customerInfo"
          :canEditMcc="canEditMcc"
          :dataConfigMcc="dataConfigMcc"
          :submitEditMcc="submitEditMcc"
        />
        <ContractInfo :contract="dataContract" :item="customerInfo" />
        <CusInfo :contract="dataContract" :item="customerInfo" />
        <BankInfo :comfirm="openUploadModalVertify" :contract="dataContract" :item="customerInfo" />
        <ReceiptInfo :contract="dataContract" :item="customerInfo" @fetch-data="fetchData()" />
        <SupportContactInfos :item="customerInfo" :systemConfig="systemConfig" />
        <PaymentAcceptancePoint :contract="dataContract" :item="customerInfo" />
      </div>
      <div class="col-md-6 px-1">
        <div class="form-detail">
          <div
            v-if="dataContract.nganluongTransferStatus"
            class="mb-3"
            style="border: 1px solid #ced4da; border-radius: 4px; padding: 15px"
          >
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h1 class="form-inner-heading mb-0">File HĐ Ngân Lượng</h1>
              <b-button
                style="width: 245px"
                v-if="dataContract?.nganluongTransferStatus !== 'APPROVED'"
                @click="
                  $refs.updateNganLuongFileModal.show(
                    dataContract?.lstAppendixNganluongConverts?.[0]
                  )
                "
              >
                <i class="bx bx-refresh mr-1"></i>Đổi file HĐ Ngân lượng
              </b-button>
            </div>
            <UploadMultiple
              :lsData="(dataContract.nganluongContractS3Url || []).map(url => ({ dataURL: url }))"
              keyUrl="dataURL"
              :canUpload="false"
              style="border: none; padding: 0"
            />
          </div>
        </div>
        <div class="form-detail">
          <div>
            <UploadMultiple
              :lsData="dataPDFContract"
              keyUrl="dataURL"
              :canUpload="false"
              title="Upload file PDF"
              titleTag="h1"
              titleClass="form-inner-heading"
            >
              <div
                v-if="
                  ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                  dataContract.state === 'SIGNED_WAITING_APPROVED'
                "
                @click="showAddImages('pdf')"
                class="add-img btn"
              >
                <span class="text-center bx bx-edit-alt"></span>
              </div>
            </UploadMultiple>
          </div>
          <UploadMultiple
            v-if="dataContract.typeCustomer === 'INDIVIDUAL'"
            :lsData="dataBillImg"
            keyUrl="dataURL"
            :canUpload="false"
            title="Ảnh hoá đơn/Ảnh selfie với cửa hàng/Ảnh sản phẩm..."
            titleTag="h1"
            titleClass="form-inner-heading"
          >
            <div
              v-if="
                ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                dataContract.state === 'SIGNED_WAITING_APPROVED'
              "
              @click="showAddImages('selfie')"
              class="add-img btn"
            >
              <span class="text-center bx bx-edit-alt"></span>
            </div>
          </UploadMultiple>
          <UploadMultiple
            v-if="['HOUSEHOLD', 'COMPANY'].includes(dataContract.typeCustomer)"
            :lsData="dataDKKDImg"
            keyUrl="dataURL"
            :canUpload="false"
            title="Ảnh giấy phép KD/Ảnh selfie/Ảnh sản phẩm/Ảnh cửa hàng..."
            titleTag="h1"
            titleClass="form-inner-heading"
          >
            <div
              v-if="
                ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                dataContract.state === 'SIGNED_WAITING_APPROVED'
              "
              @click="showAddImages('dkkd')"
              class="add-img btn"
            >
              <span class="text-center bx bx-edit-alt"></span>
            </div>
          </UploadMultiple>
          <UploadMultiple
            :lsData="dataPassportImg"
            keyUrl="dataURL"
            :canUpload="false"
            title="Ảnh CMND/CCCD/Hộ chiếu"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <div v-if="dataContract.stores">
            <div class="img-list-wrapper" v-for="(item, index) in dataContract.stores" :key="index">
              <UploadMultiple
                :lsData="[item]"
                keyUrl="dataURL"
                :canUpload="false"
                :title="`Ảnh cửa hàng: ${compact([
                  item.areaAddress,
                  item.areaDistrict,
                  item.areaCity,
                ]).join(' - ')}`"
                titleTag="h1"
                titleClass="form-inner-heading"
              >
                <div
                  v-if="
                    ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                    dataContract.state === 'SIGNED_WAITING_APPROVED'
                  "
                  @click="showAddImages('cuahang', item.areaId)"
                  class="add-img btn"
                >
                  <span class="text-center bx bx-edit-alt"></span>
                </div>
              </UploadMultiple>
            </div>
          </div>
          <div
            v-if="
              customerInfo.merchantBusinessAreas &&
              dataContract.state !== 'SIGNED_WAITING_APPROVED' &&
              !dataContract.stores
            "
          >
            <div
              class="img-list-wrapper"
              v-for="(item, index) in customerInfo.merchantBusinessAreas"
              :key="index"
            >
              <UploadMultiple
                :lsData="[item]"
                keyUrl="areaUrl"
                :canUpload="false"
                :title="`Ảnh cửa hàng: ${compact([
                  item.areaAddress,
                  item.areaDistrict,
                  item.areaCity,
                ]).join(' - ')}`"
                titleTag="h1"
                titleClass="form-inner-heading"
              />
            </div>
          </div>
          <UploadMultiple
            v-if="customerInfo.posBankUrls"
            :lsData="customerInfo.posBankUrls"
            :canUpload="false"
            title="Ảnh POS bank"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            v-if="customerInfo.finDocUrls"
            :lsData="customerInfo.finDocUrls"
            :canUpload="false"
            title="Ảnh chứng từ"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            v-if="customerInfo.businessAddressScanUrl"
            :lsData="customerInfo.businessAddressScanUrl"
            :canUpload="false"
            title="Địa điểm đăng ký kinh doanh"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
        </div>
      </div>
      <div class="col-12 px-1">
        <AppendixFeeTrans
          :items="dataContract.appendixTrans"
          :only="['APPROVE_REJECT', 'REQUEST_ADDITIONAL', 'APPROVE_REJECT_FEE']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixCredit
          :items="dataContract.appendixCredits"
          :only="['APPROVE_REJECT', 'REQUEST_ADDITIONAL', 'APPROVE_REJECT_FEE']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixRenewalSim
          @change="getDetailContract"
          v-if="dataContract.appendixSimRenew"
          :items="dataContract.appendixSimRenew"
        >
          <template #row-details="item">
            <AppendixRenewalSimDetail
              v-if="item?.appendixSimRenew.deviceInfos"
              :items="item?.appendixSimRenew.deviceInfos"
            />
          </template>
        </AppendixRenewalSim>
        <AppendixDevice
          :items="dataContract.appendixDevices"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
            'CHANGE_FILE_APPENDIX_MPOS',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
          :cfgPolicyContract="this.cfgPolicyContract"
        />
        <AppendixMultiFunctional
          :items="dataContract.appendixMultiFunctional"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'MULTI_FUNCTIONAL_APPROVE_REJECT',
            'CONFIRM_INFO_APPENDIX',
            'REQUEST_ADDITIONAL_OPTION',
            'REQUEST_ADDITIONAL_INFO',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixCashback
          :items="dataContract.appendixCashbacks"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixLend
          :items="dataContract.appendixLends"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixRent
          :items="dataContract.appendixRents"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixMoto
          :items="dataContract.appendixMoto"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL_OPTION',
            'RE_CREATE_RECEIPT',
            'CONFIRM_INFO_APPENDIX',
            'REQUEST_ADDITIONAL_INFO',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixQR
          :items="dataContract.appendixQr"
          :only="['APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixUQNH
          :items="dataContract.appendixAuthBanks"
          :only="['APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixVISA
          :items="dataContract.appendixVisas"
          :only="['CREATE_APPENDIX_VISA', 'REJECT_VISA']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixUQKHD
          :items="dataContract.appendixAuthContracts"
          :only="['APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixLiquid
          :items="dataContract.appendixLiquidDates"
          :only="['APPROVE_REJECT_LIQUID', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />

        <AppendixRecall
          :items="dataContract.appendixRecalls"
          :only="['REQUEST_ADDITIONAL', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixHandover
          :items="dataContract.appendixHandOvers"
          :only="['REQUEST_ADDITIONAL', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixTransfer
          :items="dataContract.appendixTransfers"
          :only="['REQUEST_ADDITIONAL', 'APPROVE_REJECT', 'CHANGE_FILE_APPENDIX_MPOS']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixWarranties
          :items="dataContract.appendixWarranties"
          :only="['APPROVE_REJECT', 'RE_CREATE_RECEIPT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixOnUs
          :items="dataContract.appendixOnUs"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixChange
          :items="dataContract.appendixChange"
          :only="['']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixHomePayLater
          :items="dataContract.appendixHPL"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixAppendixQrConnectors
          :items="dataContract.appendixQrConnector"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixLinkCard
          :items="dataContract.appendixLinkCard"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixNganluongConvert
          v-if="
            dataContract?.appendixNganluongConvert && dataContract?.appendixNganluongConvert.length
          "
          :items="dataContract.appendixNganluongConvert"
          :only="['VIEW_APPENDIX', 'CHANGE_FILE_NGANLUONG_CONVERT', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <SignHistory :contractId="$route.params.id" />
        <div class="form-detail" v-if="historyUpdate.length > 0">
          <h1>Lịch sử chỉnh sửa thông tin hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thông tin chỉnh sửa</th>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale</th>
                  <th scope="col" class="text-left">Người duyệt/ từ chối</th>
                  <th scope="col" class="text-left">Lý do từ chối</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyUpdate" :key="index">
                <tr class="table-row">
                  <td align="left">
                    <router-link :to="`/history-approve-update/${item.updateCusReqId}`"
                      >Xem chi tiết</router-link
                    >
                  </td>
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.saleName }} <br />
                    <p class="text-primary">{{ item.saleEmail }}</p>
                  </td>
                  <td align="left">
                    <div v-if="item.rejectName">
                      {{ item.rejectName }} <br />
                      <p class="text-primary">{{ item.rejectEmail }}</p>
                    </div>
                    <div v-else>
                      {{ item.approverName }} <br />
                      <p class="text-primary">{{ item.approverEmail }}</p>
                    </div>
                  </td>
                  <td align="left">
                    {{ item.reason }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="form-detail" v-if="historyAssignSale.length > 0">
          <h1>Lịch sử gán hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale cũ</th>
                  <th scope="col" class="text-left">Sale đang gán</th>
                  <th scope="col" class="text-left">Người gán</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyAssignSale" :key="index">
                <tr class="table-row">
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.oldSaleName }} <br />
                    <p class="text-primary">{{ item.oldSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.newSaleName }} <br />
                    <p class="text-primary">{{ item.newSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.approverName }} <br />
                    <p class="text-primary">{{ item.approverEmail }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <HistoryInfo :dataContract="dataContract"></HistoryInfo>
      </div>
    </div>

    <addPDF
      :showModalAddBillImages="showModalAddPDF"
      :dataImagesContract="dataPDFContract"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddBillImages="addPDFImages"
      @close="closeAddImages('pdf')"
    >
    </addPDF>

    <addBillImages
      :showModalAddBillImages="showModalAddBillImages"
      :dataImagesContract="dataBillImg"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddBillImages="addBillImages"
      @close="closeAddImages('bill')"
    >
    </addBillImages>

    <addDKKDImages
      :showModalAddDKKDImages="showModalAddDKKDImages"
      :dataImagesContract="dataDKKDImg"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddDKKDImages="addDKKDImages"
      @close="closeAddImages('dkkd')"
    >
    </addDKKDImages>

    <addStoreImages
      :showModalAddStoreImages="showModalAddStoreImages"
      :dataImagesContract="dataImgStores"
      :dataIdStores="dataIdStores"
      :dataContract="dataContract"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddImagesStore="addStoreImages"
      @close="closeAddImages('store')"
    >
    </addStoreImages>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <SelectEmployee @selectSale="assignNewSale" />
    <PopupApproveContract
      :customer-type="customerInfo?.customerType"
      ref="popupApproveContractRef"
      @approveContract="getDetailContract"
      :dataDetail="dataContract"
    />
    <approve-reject-component
      @reject="openReject"
      @approve="handleApproveHandover(dataContract.id)"
      :disable-upload="true"
      ref="modal-confirm"
      :selected-item="selectedItem"
    />

    <dkkd-modal ref="modal-dkkd" :contractId="dataContract.id" @approve="handleUpdateContract" />

    <tpv-modal ref="modal-tpv" :dataContract="dataContract" @approve="handleUpdateContract" />

    <b-modal id="modal-scoped" v-model="showModal" @hide="handleCloseReject">
      <template #modal-header="{ close }">
        <h5>Bạn chắc chắn muốn từ chối bàn giao thiết bị?</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="">
        <p class="f14 pb-2">Lý do từ chối yêu cầu</p>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleReject)">
            <ValidationProvider rules="required|minMaxName_4" name="Lý do" v-slot="{ errors }">
              <b-form-group label="" label-for="floatingTextarea2">
                <b-form-textarea
                  id="floatingTextarea2"
                  v-model="reason"
                  placeholder="Lý do"
                  rows="3"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="input-live-feedback">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Huỷ bỏ </b-button>
        <b-button size="sm" variant="primary" @click="handleReject"> Đồng ý </b-button>
      </template>
    </b-modal>
    <input
      ref="fileInput"
      type="file"
      accept="application/pdf"
      @change="handleFileChange"
      style="display: none"
    />
    <UploadModalVertify
      ref="uploadModal"
      :visible="showUploadModal"
      :initialData="[]"
      @update:visible="showUploadModal = $event"
      @success="getDetailContract"
      :contractId="dataContract?.id"
      :customerId="dataContract?.customerId"
      :reqSellCode="dataContract?.reqSellCode"
    />
    <TransferNganLuongModal
      ref="transferNganLuongModal"
      :contractId="dataContract?.id"
      @success="fetchData"
    />
    <UpdateNganLuongFileModal
      ref="updateNganLuongFileModal"
      :contractId="dataContract?.id || ''"
      :appendixId="dataContract?.lstAppendixNganluongConverts?.[0]?.appendixId || ''"
      @success="fetchData"
    />

    <UpdateNganluongConvertFileModal
      ref="updateNlConvertModal"
      :contractId="dataContract?.id || ''"
      :appendixId="dataContract?.lstAppendixNganluongConverts?.[0]?.appendixId || ''"
      @success="fetchData"
    />

    <b-modal
      id="modal-approve-transfer-nl"
      v-model="showmodalApproveTransferNL"
      title="Duyệt yêu cầu chuyển đổi"
    >
      <p>Bạn chắc chắn muốn duyệt yêu cầu chuyển đổi HĐ Ngân Lượng này?</p>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button variant="success" @click="approveTransferNganLuong"> Duyệt </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-reject-transfer-nl"
      v-model="showmodalRejectTransferNL"
      title="Từ chối yêu cầu chuyển đổi"
      @hide="reasonCancelNganluong = ''"
    >
      <div class="">
        <p class="f14 pb-2">Lý do từ chối yêu cầu <span class="text-danger">*</span></p>
        <b-form-textarea
          v-model="reasonCancelNganluong"
          placeholder="Nhập lý do từ chối"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button
          variant="danger"
          @click="rejectTransferNganLuong"
          :disabled="!reasonCancelNganluong || !reasonCancelNganluong.trim()"
        >
          Từ chối
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import compact from 'lodash/compact'
  import { ContractService } from '@/services/contract.service'
  import Config from '../../thirdParty/config'
  import AddPDF from './modal-add-image/pdf-add-file.vue'
  import AddBillImages from './modal-add-image/bill-add-images'
  import AddDKKDImages from './modal-add-image/dkkd-add-images'
  import AddStoreImages from './modal-add-image/store-add-images'
  import mxActions from './mxActions'
  import mxAppendix from './mxAppendix'
  import HistoryInfo from './component/HistoryInfo.vue'
  import ApproveRejectComponent from '@/pages/device/equipmentHandover/components/ApproveRejectComponent.vue'
  import DkkdModal from '@/pages/contract/component/DkkdModal.vue'
  import TpvModal from '@/pages/contract/component/TpvModal.vue'
  import { CommonService } from '@/services/common.service'
  import UploadModalVertify from './component/UploadModalVertify.vue'
  import AppendixRenewalSim from './component/appendix/AppendixRenewalSim.vue'
  import AppendixRenewalSimDetail from './component/appendix/AppendixRenewalSimDetail.vue'
  import TransferNganLuongModal from './component/TransferNganLuongModal.vue'
  import AppendixNganluongConvert from './component/appendix/AppendixNganluongConvert.vue'
  import UpdateNganluongConvertFileModal from './component/appendix/UpdateNganluongConvertFileModal.vue'
  import UpdateNganLuongFileModal from './component/UpdateNganLuongFileModal.vue'

  export default {
    data() {
      return {
        Config,
        dataContract: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        showModalAddPDF: false,
        showModalAddBillImages: false,
        showModalAddDKKDImages: false,
        showModalAddStoreImages: false,
        showModal: false,
        dataPDFContract: [],
        dataBillImg: [],
        dataDKKDImg: [],
        dataPassportImg: [],
        generalImages: [],
        dataConfigMcc: [],
        dataImgStores: [],
        dataIdStores: '',
        selectedItem: {},
        showLoading: false,
        historyUpdate: [],
        historyAssignSale: [],
        canEditMcc: false,
        dataChangeFileAppendixMpos: '',
        showUploadModal: false,
        showmodalApproveTransferNL: false,
        showmodalRejectTransferNL: false,
        reasonCancelNganluong: '',
      }
    },
    computed: {
      extendedContractAction() {
        return [
          ...this.defaultContractAction,
          // {
          //   code: 'TRANSFER_NGANLUONG',
          //   text: 'Chuyển đổi HĐ ngân lượng',
          //   variant: 'primary',
          //   condition:
          //     ((['APPROVED', 'PENDING_APPROVAL', 'PENDING_CONFIRM_APPROVAL', 'ACTIVE'].includes(
          //       this.dataContract.state
          //     ) &&
          //       !this.dataContract?.isNganluongContract) ||
          //       (this.dataContract?.nganluongTransferStatus === 'REJECTED' &&
          //         this.dataContract?.isNganluongContract)) &&
          //     this.dataContract?.service === 'MPOS',
          //   action: () => {
          //     if (this.$refs.transferNganLuongModal) {
          //       this.$refs.transferNganLuongModal.show()
          //     }
          //   },
          // },
        ]
      },
    },

    components: {
      DkkdModal,
      TpvModal,
      ApproveRejectComponent,
      addPDF: AddPDF,
      addBillImages: AddBillImages,
      addStoreImages: AddStoreImages,
      addDKKDImages: AddDKKDImages,
      HistoryInfo,
      UploadModalVertify,
      AppendixRenewalSim,
      AppendixRenewalSimDetail,
      TransferNganLuongModal,
      AppendixNganluongConvert,
      UpdateNganluongConvertFileModal,
      UpdateNganLuongFileModal,
    },
    mixins: [mxActions, mxAppendix],
    async created() {
      this.fetchData()
      this.getConfigSystem()
    },
    methods: {
      compact,
      openUploadModalVertify() {
        this.showUploadModal = true
      },
      openReject() {
        this.showModal = true
      },

      async handleReject() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return
        this.showModal = false
        await this.confirmHandover('Từ chối bàn giao thiết bị', {
          action: 'REJECTED',
          contractId: this.selectedItem.appendixId,
          contractType: 'APPENDIX',
          reason: this.reason,
        })
      },
      async fetchData() {
        await this.getDetailContract()
        this.configSystem()
        await this.getHistoryUpdate()
        this.historySaleAssigned()
      },
      async handleApproveHandover() {
        await this.confirmHandover('Duyệt xác nhận bàn giao', {
          action: 'SUCCESS',
          contractId: this.selectedItem.appendixId,
          contractType: 'APPENDIX',
        })
      },
      async getDetailContract() {
        try {
          this.showLoading = true
          const data = await ContractService.getDetailPaperContractById({
            contractId: this.$route.params.id,
          })
          if (data.code === 1000 && data.data) {
            this.dataContract = data.data
            if (this.dataContract.generalImages) {
              this.dataPDFContract = this.dataContract.generalImages.filter(
                item => item.dataType === 'PDF'
              )
              this.dataBillImg = this.dataContract.generalImages.filter(
                item => item.dataType === 'BILL'
              )
              this.dataDKKDImg = this.dataContract.generalImages.filter(
                item => item.dataType === 'BUSINESSREG'
              )
              this.dataPassportImg = this.dataContract.generalImages.filter(
                item => item.dataType === 'CMND'
              )
              this.generalImages = this.dataContract.generalImages
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      successUploadImg(key) {
        this.showLoading = false
        if (key === 0) {
          this.showSuccessMx('Thêm phụ lục thành công')
        }
        if (key === 1) {
          this.showSuccessMx('Cập nhật ảnh thành công')
        }
        if (key === 2) {
          this.showSuccessMx('Cập nhật file PDF thành công')
        }
      },

      closeAddImages(key) {
        if (key === 'pdf') this.showModalAddPDF = false
        if (key === 'bill') this.showModalAddBillImages = false
        if (key === 'store') this.showModalAddStoreImages = false
        if (key === 'dkkd') this.showModalAddDKKDImages = false
        setTimeout(() => {
          this.getDetailContract()
        }, 200)
      },

      showAddImages(typeImage, data) {
        if (typeImage === 'pdf') this.showModalAddPDF = true
        if (typeImage === 'selfie') this.showModalAddBillImages = true
        if (typeImage === 'cuahang') {
          this.showModalAddStoreImages = true
          this.dataImgStores = this.dataContract.stores.filter(e => e.areaId === data)
          this.dataIdStores = data
        }
        if (typeImage === 'dkkd') this.showModalAddDKKDImages = true
      },

      addPDFImages(data) {
        this.dataPDFContract = data.dataImages
        this.showModalAddPDF = false
      },
      addBillImages(data) {
        this.dataBillImg = data.dataImages
        this.showModalAddBillImages = false
      },
      addDKKDImages(data) {
        this.dataDKKDImg = data.dataImages
        this.showModalAddDKKDImages = false
      },
      addStoreImages(data) {
        this.dataContract.stores = data.dataImages
        this.showModalAddStoreImages = false
      },
      handleCloseReject() {
        this.reason = ''
      },
      actionSelectFileAppendixMpos(appendixId) {
        this.$refs.fileInput.click()
        this.dataChangeFileAppendixMpos = appendixId
      },
      handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          this.sendDocument(file)
        } else {
          console.log('Không có file nào được chọn.')
        }
      },
      async sendDocument(file) {
        try {
          // this.showLoading = true;
          if (file) {
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const response = await CommonService.uploadFile(formData)
            if (response.code === 1000) {
              const urlFile = response.data
              this.changeFileAppendixMpos(urlFile)
              // return urlFile
            } else {
              this.showFailMx(response.message)
            }
          } else {
            return null
          }
        } catch (error) {
          console.log(error)
        }
      },
      async changeFileAppendixMpos(urlFile) {
        try {
          this.showLoading = true
          const body = {
            appendixId: this.dataChangeFileAppendixMpos,
            urlPdf: urlFile[0],
          }
          const response = await ContractService.changeFileAppendixMpos(body)
          if (response.code === 1000) {
            this.showSuccessMx('Thay đổi file thành công')
            this.getDetailContract()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.dataChangeFileAppendixMpos = ''
        }
      },
      async approveTransferNganLuong() {
        try {
          this.showLoading = true
          const response = await ContractService.approveTransferToNganLuongContract({
            contractId: this.dataContract.id,
          })
          if (response.code === 1000) {
            this.showSuccessMx('Duyệt yêu cầu thành công')
            this.showmodalApproveTransferNL = false
            this.getDetailContract()
          } else {
            this.showFailMx(response.message || 'Có lỗi xảy ra')
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async rejectTransferNganLuong() {
        if (!this.reasonCancelNganluong || !this.reasonCancelNganluong.trim()) return
        try {
          this.showLoading = true
          const response = await ContractService.rejectTransferToNganLuongContract({
            contractId: this.dataContract.id,
            reasonCancel: this.reasonCancelNganluong,
          })
          if (response.code === 1000) {
            this.showSuccessMx('Từ chối yêu cầu thành công')
            this.showmodalRejectTransferNL = false
            this.getDetailContract()
          } else {
            this.showFailMx(response.message || 'Có lỗi xảy ra')
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
    filters: {
      mapNganluongTransferStatus(status) {
        if (!status) return ''
        const statusMap = {
          PENDING: 'Chờ duyệt',
          APPROVED: 'Hoàn thành',
          REJECTED: 'Từ chối',
          MC_SIGNED_WAITING_NL_SIGN: 'MC đã ký, chờ NL ký',
        }
        return statusMap[status] || status
      },
    },
  }
</script>

<style scoped>
  .btn .bx {
    font-size: 18px;
  }

  .dropdown-item button {
    border: 1px;
  }

  .PENDING {
    color: #fff;
    background-color: #ffc107;
  }
  .APPROVED {
    color: #fff;
    background-color: #28a745;
  }
  .REJECTED {
    color: #fff;
    background-color: #dc3545;
  }
</style>
